var klaviyo = klaviyo || [];
klaviyo.init({
  account: "UgRPBn",
  platform: "shopify",
  list: "XffGAF",
});
klaviyo.enable("backinstock", { 
  trigger: {
    product_page_text: "Fá tilkynningu þegar varan kemur aftur",
    product_page_class: "product-form__submit button button--full-width button--primary button--backinstock-override",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: true
  },
  modal: {
    headline: "{product_name}",
    body_content: "Skráðu þig til að fá tilkynningu þegar varan kemur aftur.",
    newsletter_subscribe_label: "Bæta mér einnig á póstlista Dimm.",
    email_field_label: "Netfang",
    button_label: "Fá tilkynningu",
    subscription_success_label: "Netfang skráð! Við látum þig vita þegar varan kemur aftur.",
    footer_content: "",
    additional_styles: "form button[type='submit'] { font-weight: 400; letter-spacing: 1px; }",
    close_label: "Loka",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "rgb(18, 18, 18)",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500"
  }
});